import { Access } from "@p0security/shared/types/access/index";

export const AppAccesses = {
  // Named "access": this integration has exactly one access type.
  access: Access({
    description:
      "A policy on a custom connector deployment, granted through the connector code your organization deployed and P0 never reads",
    label: "Access",
    maturity: "preview",
    delegation: {},
    generated: {},
    parameters: {
      // Static: install items come from configuration, not a connector list.
      locator: {
        type: "static",
        label: "Application",
        description: "The custom application deployment to request through",
      },
      // Dynamic: fetches only when the dropdown opens, so a slow connector
      // doesn't block the whole request modal.
      policy: {
        type: "dynamic",
        label: "Policy",
        description:
          "An opaque policy string served by the custom connector's `list` primitive; P0 never interprets it",
        multivalued: true,
      },
    },
    render: { locator: "locator", policy: "policy" } as const,
  }),
};

export type AppAccesses = typeof AppAccesses;
export type AppAccess = AppAccesses[keyof AppAccesses];
export type AppAccessAccess = AppAccesses["access"];
